import img1 from '../assets/images/gallery/ARTE-1.jpg'
import img2 from '../assets/images/gallery/ARTE-2.jpg'
import img3 from '../assets/images/gallery/ARTE-3.jpg'
import img4 from '../assets/images/gallery/ARTE-4.jpg'
import img5 from '../assets/images/gallery/ARTE-5.jpg'

import img6 from '../assets/images/gallery/ANA-MARIA-ANGEL-ZONA-LOVE.png'
import img7 from '../assets/images/gallery/LAURA-LEMA-Flor_Mensual.png'
import img8 from '../assets/images/gallery/ANA-JARAMILLO-AMAR-LO-QUE-NOS-HACE-NOSOTRAS.png'
import img9 from '../assets/images/gallery/KEVIN-MARTINEZ-SOMOS-2.png'
import img10 from '../assets/images/gallery/ANA-MARIA-ANGEL-DIAS-DE-PODER.png'
import img11 from '../assets/images/gallery/VERONICA-ORTEGA-NATURALEZA-DE-VIDA-BY-VOS.GRAFICA.png'
import img12 from '../assets/images/gallery/LAURA-GALLEGO-UN-PUNTO-QUE-FLORECE.png'

const imagesGallery = [
  {
    img: img1,
    title: '28 días',
    author: 'María Alejandra Maya - 28 años',
  },
  {
    img: img2,
    title: 'Simetría',
    author: 'María Alejandra Maya - 28 años',
  },
  {
    img: img3,
    title: 'Día dos',
    author: 'Vanessa López - 32 años',
  },
  {
    img: img4,
    title: 'Amor propio',
    author: 'Vanessa López - 32 años',
  },
  {
    img: img5,
    title: 'Monarca',
    author: 'Elisa Henao - 25 años',
  },
  {
    img: img6,
    title: 'Zona love',
    author: 'Ana Maria Ángel - 35 años',
  },
  {
    img: img7,
    title: 'Flor Mensual by @lalita_Illustration',
    author: 'Laura Lema - 26 años',
  },
  {
    img: img8,
    title: 'Amar lo que nos hace nosotras',
    author: 'Ana Jaramillo - 26 años',
  },
  {
    img: img9,
    title: 'Somos 2',
    author: 'Kevin Martínez - 26 años',
  },
  {
    img: img10,
    title: 'Días de poder',
    author: 'Ana Maria Ángel - 35 años',
  },
  {
    img: img11,
    title: 'Naturaleza de vida by vos.grafica',
    author: 'Verónica Ortega - 26 años',
  },
  {
    img: img12,
    title: 'Un punto que florece',
    author: 'Laura Gallego - 28 años',
  },
]

export default imagesGallery
